/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Nav_Reservations_DescriptionInputs */

const en_inventory_nav_reservations_description = /** @type {(inputs: Inventory_Nav_Reservations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage inventory holds and reservations`)
};

const es_inventory_nav_reservations_description = /** @type {(inputs: Inventory_Nav_Reservations_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar apartados y reservas`)
};

/**
* | output |
* | --- |
* | "Manage inventory holds and reservations" |
*
* @param {Inventory_Nav_Reservations_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_nav_reservations_description = /** @type {((inputs?: Inventory_Nav_Reservations_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Nav_Reservations_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_nav_reservations_description(inputs)
	return es_inventory_nav_reservations_description(inputs)
});